<template lang="pug">
div
  router-view
  //- preload
</template>

<script>
import preload from './components/Stu/StuPractice/StuExam/preLoad'
import { getStudentInfo, sso } from '@/api/index'
import Util from '@/util/Util'

const token_ = Util.getCookieValue('token')

export default {
  name: 'App',
  components: { preload },
  methods: {
    initSocket(data) {
      let that = this
      this.$socket.on('connect', () => {
        that.$socket.emit('login', {
          uid: 's_' + data.id,
          scid: 'sc_' + data.school_class_id || '',
          cname: data.category_name || '',
          cid: data.country_id || '',
          lid: data.layer_id ? 'l_' + data.layer_id : ''
        })
      })

      this.sockets.subscribe('new_msg', data => {
        console.info('new_msg', data)
      })
      this.sockets.subscribe('update_online_count', data => {
        console.info('update_online_count', data)
      })
      if (!token_) {
        this.sockets.subscribe('oss', data => {
          // 单点登录
          this.$store.dispatch('oss', data)
        })
      }
      this.sockets.subscribe('newTask', data => {
        // 新练习推送
        this.$store.dispatch('newTask', data)
      })
    }
  },
  beforeCreate() {
    document.title = window.ConfigNew.header.title
    // 获取学生信息，存入store中
    getStudentInfo(res => {
      if (res.status === 1) {
        let data = res.data
        this.$store.commit('student/init', data)
        this.$store.commit('setVipInfo', data.vip)
        localStorage.setItem(
          'defaultGrade',
          JSON.stringify(res.data.defaultGrade)
        )
        if (!token_) {
          if (!localStorage.getItem('socketToken')) {
            localStorage.setItem(
              'socketToken',
              new Date().getTime() + Math.random().toFixed(10)
            )
          }
          sso({ token: localStorage.getItem('socketToken') })
        }
        this.initSocket(data)
      } else this.requestFail(res)
    })
  }
}
</script>

<style>
@import url('./ui/css/ui.css');
#app {
  min-width: 1180px;
  min-height: 100vh;
}
.iconfont {
  font-family: 'iconfont' !important;
  font-size: 16px;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -webkit-text-stroke-width: 0.2px;
  -moz-osx-font-smoothing: grayscale;
}
@font-face {
  font-family: 'iconfont'; /* project id 986912 */
  src: url('//at.alicdn.com/t/font_986912_8c1wwvxsspd.eot');
  src: url('//at.alicdn.com/t/font_986912_8c1wwvxsspd.eot?#iefix')
      format('embedded-opentype'),
    url('//at.alicdn.com/t/font_986912_8c1wwvxsspd.woff2') format('woff2'),
    url('//at.alicdn.com/t/font_986912_8c1wwvxsspd.woff') format('woff'),
    url('//at.alicdn.com/t/font_986912_8c1wwvxsspd.ttf') format('truetype'),
    url('//at.alicdn.com/t/font_986912_8c1wwvxsspd.svg#iconfont') format('svg');
}
</style>



// WEBPACK FOOTER //
// src/App.vue